import { useAppContext } from '.'

export function useSubscriptionStatus() {
  const contextQuery = useAppContext()
  const user = contextQuery.data?.user

  return user?.subscriptionStatus
}
